import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa9be90a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "footStepsArea"
}
const _hoisted_2 = {
  key: 0,
  class: "podium"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-flag" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "footStepUpdate"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GoogleAPIStepsCounter = _resolveComponent("GoogleAPIStepsCounter")!

  return ($setup.canUDisplayFootSteps($props.aAdTransaction))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          ($props.footPodium)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                _createTextVNode(_toDisplayString($props.footPodium) + " ", 1),
                _hoisted_3,
                _createTextVNode(" , ")
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString($setup.displayFootStepCounter($props.aAdTransaction.ATFootStepCount)), 1)
        ]),
        ($setup.canUpdateFootSteps($props.aAdTransaction))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_GoogleAPIStepsCounter, {
                onNewFootStepsValueFromGoogleAPI: $setup.updateFootStep,
                startTime: $props.aAdDoc.getValueADDateHourStartsOn(),
                endTime: $props.aAdDoc.getValueADDateHourEndsOn()
              }, null, 8, ["onNewFootStepsValueFromGoogleAPI", "startTime", "endTime"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}